/**
 * @param {string} pathname
 * @param {string} path
 * @returns {boolean}
 */
function isPathActive(pathname, path) {
  if (pathname === path) {
    return true;
  }

  return pathname.startsWith(`${path}/`);
}

/**
 * @param {string} pathname
 * @param {{ path: string, paths?: string[] }} tab
 * @returns {boolean}
 */
export function isMobileTabPathActive(pathname, tab) {
  const candidates = tab.paths?.length ? tab.paths : [tab.path];

  return candidates.some((path) => isPathActive(pathname, path));
}
